function t(){return"function"==typeof Symbol&&Symbol.iterator?Symbol.iterator:"@@iterator"}var o=t();export{t as getSymbolIterator,o as iterator};
